export const styles = {
  actionButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '12px',
    marginTop: '40px',
  },
  cancelButton: {
    maxWidth: '70px',
    width: '70px',
    minWidth: 'auto',
  },
  actionButton: {
    maxWidth: '104px',
    width: '104px',
    minWidth: 'auto',
  },
};
